import { apiClient } from '../../../../api/axios';
import type { ApiResponse } from '../common/types';
import type {
    CollectiveAssessmentData,
    FinalDecisionSubmission,
    AssessmentDraftItem,
    GetFinalDecisionPayload,
} from './types';

export const approvalService = {
    getCollectiveAssessmentCount: async (payload: { averageScore: number; applicationType: number; thematicAreaId: number }): Promise<ApiResponse<CollectiveAssessmentData>> => {
        const response = await apiClient.get('/Approvals/GetCollectiveAssessmentCount', {
            params: {
                averageScore: payload.averageScore,
                applicationType: payload.applicationType,
                categoryId: payload.thematicAreaId,
            },
        });
        return response.data;
    },

    getAssessmentDraft: async (payload: { averageScore: number; applicationType: number; getBelowAverage: boolean; thematicAreaId: number }): Promise<ApiResponse<AssessmentDraftItem[]>> => {
        const response = await apiClient.post('/Approvals/GetAssessmentDraft', {
            averageScore: payload.averageScore,
            applicationType: payload.applicationType,
            getBelowAverage: payload.getBelowAverage,
            thematicAreaId: payload.thematicAreaId,
        });
        return response.data;
    },

    makeApprovalDecision: async (averageScore: number, applicationType: number, categoryId: number = 0): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(`/Approvals/MakeApprovalDecision?averageScore=${averageScore}&applicationType=${applicationType}&categoryId=${categoryId}`);
        return response.data;
    },

    getFinalDecision: async (payload: GetFinalDecisionPayload): Promise<ApiResponse<FinalDecisionSubmission[]>> => {
        const response = await apiClient.post('/Approvals/GetFinalDecision', payload);
        return response.data;
    }
};
